import { useState } from 'react';

import { Button, toast } from '@raystack/apsara';
import { DialogModal } from '@studio/components';
import { Show } from '@studio/hoc';
import { AxiosError } from 'axios';

import { useCopilotDispatch, useCopilotSelector } from '@src/contexts';
import { deleteChat } from '@src/utils/apis/SeekerApis';
import {
  HISTORY_ATTRS_DEFAULT_VALUE,
  MULTI_CHAT_STEPS
} from '@src/utils/constants/COPILOT_CONSTANTS';
import { DeleteChatProps } from '@src/utils/types/CopilotTypes';

export const DeleteChatModal = ({
  chatId,
  open,
  setOpen,
  closePopover
}: DeleteChatProps) => {
  const existingChatId = useCopilotSelector(state => state.chatId);
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useCopilotDispatch();

  const handleDeleteChat = async () => {
    setIsLoading(true);
    try {
      await deleteChat(chatId);
      setOpen(false);
      dispatch({
        historyAttrs: HISTORY_ATTRS_DEFAULT_VALUE
      });
      closePopover();
      if (chatId === existingChatId) {
        dispatch({
          multiChatStep: MULTI_CHAT_STEPS.WELCOME,
          chatId: '',
          msgFetchFailed: false
        });
      }
    } catch (error) {
      console.error(error);
      toast.error('Failed to delete chat', {
        description: (error as AxiosError)?.response?.data?.error?.message || ''
      });
    } finally {
      setIsLoading(false);
      setOpen(false);
    }
  };

  const buttons = [
    <Button
      key={0}
      variant='solid'
      color='danger'
      loading={isLoading}
      disabled={isLoading}
      loaderText='Deleting...'
      onClick={handleDeleteChat}
      data-test-id='delete-chat'
    >
      Delete
    </Button>
  ];
  return (
    <Show when={open}>
      <DialogModal
        onClose={() => setOpen(false)}
        actionButtons={buttons}
        heading='Delete Chat'
        subHeading='This action is irreversible and may result in the deletion of all the chat logs. Are you sure you want to proceed?'
      />
    </Show>
  );
};
